<template>
  <div class="goodList">
    <template v-for="good in goodsList">
      <div
        class="mar10-t radius5 bg-white"
        v-if="good.picUrlCover || good.videoUrl"
        :key="good.goodsId"
      >
        <div class="good-cover">
          <div
            class="relative h100-full text-center overflow radius5"
            v-if="good.videoUrl"
            @click="showVideo(good.videoUrl)"
          >
            <van-image
              v-if="good.picUrlCover"
              lazy-load
              class="radius5-t"
              :src="`${good.picUrlCover}?imageView2/1/w/700/h/260`"
            />
            <van-image
              class="absolute van-center"
              fit="scale-down"
              v-else-if="good.goodsImg"
              lazy-load
              :src="good.goodsImg"
            />
            <img class="video_play_icon" src="@/assets/images/index/video_play_icon.png" alt="" />
          </div>
          <van-image
            v-else-if="good.picUrlCover"
            lazy-load
            class="radius5-t"
            :src="`${good.picUrlCover}?imageView2/1/w/700/h/260`"
          />
        </div>
        <div
          class="pad10 flex flex-column justify-between"
          @click="routerClick(`/goodDetails/${good.goodsId}`)"
        >
          <div class="fb ellipsis_two lin18 mar5-b">
            <img
              class="h20 mar5-r"
              v-if="good.isShowFarmersDayLabel"
              src="https://nfs.nxin.com/cms_image_546d8af9-8df0-47d0-8fe7-df4e51e209e7.png"
            />
            <img
              class="w28 mar3-r"
              v-if="good.isOptimization == 1"
              src="@/assets/images/index/yx.png"
              alt=""
            />
            <template v-if="good.goodsTagList && good.goodsTagList.length">
              <span class="h20 relative good_vip mar5_r" v-for="tag in good.goodsTagList">{{tag}}</span>
            </template>
            {{ good.goodsNameStr ? good.goodsNameStr : good.goodsName }}
          </div>
          <div class="flex items-center justify-between">
            <div class="red fb flex items-baseline">
              <template v-if="good.sellFactPrice">
                <img
                  class="h15 mar5-r"
                  v-if="good.goodsPriceMemberLevel === '1'"
                  src="https://filesouthcdn.nxin.com/nxsc_1673594227817048312274484025897.png"
                />
                <img
                  class="h15 mar5-r"
                  v-else-if="good.goodsPriceMemberLevel === '2'"
                  src="https://filesouthcdn.nxin.com/nxsc_1673594103328010438901425013813.png"
                />
                <img
                  class="h15 mar5-r"
                  v-else-if="good.goodsPriceMemberLevel === '3'"
                  src="https://filesouthcdn.nxin.com/nxsc_167359420355106278603546708517.png"
                />
                <img
                  class="h15 mar5-r"
                  v-else-if="good.goodsPriceMemberLevel === '4'"
                  src="https://filesouthcdn.nxin.com/nxsc_1673594183138006841962992133843.png"
                />
                <div>
                  <span class="f10">￥</span>
                  <span class="f16">{{ good.price[0] }}</span>
                  <span class="f10">.{{ good.price[1] }}</span>
                </div>
                <!-- <span class="f10 gray6 fb-small">￥{{ good.vipMoney }}</span> -->
                <!-- <img class="h15 mar5-l" v-if="good.vipMoney" src="@/assets/images/index/vip-icon.png" alt=""> -->
                <img
                  class="h15 mar5-l"
                  v-if="good.promotionTypeEng === 'GROUP_PURCHASE'"
                  src="@/assets/images/index/jc.png"
                  alt=""
                />
                <img
                  class="h15 mar5-l"
                  v-if="good.promotionTypeEng === 'DIRECT_SELLING'"
                  src="@/assets/images/index/zj.png"
                  alt=""
                />
                <img
                  class="h15 mar5-l"
                  v-if="good.promotionTypeEng === 'BUY_GIFTS'"
                  src="@/assets/images/index/mz.png"
                  alt=""
                />
              </template>
              <span v-else class="f12">点击询价</span>
            </div>
            <img
              v-if="good.sellFactPrice"
              @click.stop="addCart(good)"
              class="w20"
              src="@/assets/images/index/cart-add.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div
        class="mar10-t radius5 bg-white flex pad10"
        v-else
        :key="good.goodsId"
        @click="routerClick(`/goodDetails/${good.goodsId}`)"
      >
        <div class="good-img flex-shrink">
          <van-image
            v-if="good.goodsImg"
            lazy-load
            :src="`${good.goodsImg}?imageView2/1/w/200/h/200`"
          />
          <img v-else src="@/assets/images/good/good-none.png" class="radius5" />
        </div>
        <div class="pad10-l pad5-tb flex flex-auto flex-column justify-between">
          <div class="fb ellipsis_two lin18">
            <img
              class="h20 mar5-r"
              v-if="good.isShowFarmersDayLabel"
              src="https://nfs.nxin.com/cms_image_546d8af9-8df0-47d0-8fe7-df4e51e209e7.png"
            />
            <img
              class="w28 mar3-r"
              v-if="good.isOptimization == 1"
              src="@/assets/images/index/yx.png"
              alt=""
            />
            <template v-if="good.goodsTagList && good.goodsTagList.length">
              <span class="h20 relative good_vip mar5_r" v-for="tag in good.goodsTagList">{{tag}}</span>
            </template>
            {{ good.goodsNameStr ? good.goodsNameStr : good.goodsName }}
          </div>
          <div class="flex items-center justify-between">
            <div>
              <div class="flex items-baseline">
                <template v-if="good.sellFactPrice">
                  <img
                    class="h15 mar5-r"
                    v-if="good.goodsPriceMemberLevel === '1'"
                    src="https://filesouthcdn.nxin.com/nxsc_1673594227817048312274484025897.png"
                  />
                  <img
                    class="h15 mar5-r"
                    v-else-if="good.goodsPriceMemberLevel === '2'"
                    src="https://filesouthcdn.nxin.com/nxsc_1673594103328010438901425013813.png"
                  />
                  <img
                    class="h15 mar5-r"
                    v-else-if="good.goodsPriceMemberLevel === '3'"
                    src="https://filesouthcdn.nxin.com/nxsc_167359420355106278603546708517.png"
                  />
                  <img
                    class="h15 mar5-r"
                    v-else-if="good.goodsPriceMemberLevel === '4'"
                    src="https://filesouthcdn.nxin.com/nxsc_1673594183138006841962992133843.png"
                  />
                  <div class="red fb">
                    <span class="f10">￥</span>
                    <span class="f16">{{ good.price[0] }}</span>
                    <span class="f10">.{{ good.price[1] }}</span>
                  </div>
                </template>
                <span v-else>点击询价</span>
              </div>
              <div class="mar3-t">
                <!-- <img class="h15" v-if="good.vipMoney" src="@/assets/images/index/vip-icon.png" alt=""> -->
                <img
                  class="h15 mar5-l"
                  v-if="good.promotionTypeEng === 'GROUP_PURCHASE'"
                  src="@/assets/images/index/jc.png"
                  alt=""
                />
                <img
                  class="h15 mar5-l"
                  v-if="good.promotionTypeEng === 'DIRECT_SELLING'"
                  src="@/assets/images/index/zj.png"
                  alt=""
                />
                <img
                  class="h15 mar5-l"
                  v-if="good.promotionTypeEng === 'BUY_GIFTS'"
                  src="@/assets/images/index/mz.png"
                  alt=""
                />
              </div>
            </div>
            <img
              v-if="good.sellFactPrice"
              @click.stop="addCart(good)"
              class="w20"
              src="@/assets/images/index/cart-add.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </template>
    <!-- 视频 -->
    <div class="video-wrap flex flex-column pad50-b" v-if="isShow">
      <div class="fb text-right pad10" @click="closeVideo">
        <img class="w25 h25" src="@/assets/images/index/close.png" />
      </div>
      <vueMiniPlayer class="flex-auto w100-full" ref="vueMiniPlayer" :video="video" :mutex="true" />
    </div>
    <!--加购物车选择规则弹框-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="addCartShow" :safe-area-inset-bottom="true" closeable round>
      <div class="addCart_pop">
        <div class="addCart_pop_main flex flex-column">
          <div class="clear addCart_good_info flex">
            <!-- <img class="float-left" :src="detail.imgUrl1" alt=""> -->
            <div class="addCart_img flex-shrink">
              <van-image
                v-if="detail.goodsImg"
                lazy-load
                :src="`${detail.goodsImg}?imageView2/1/w/150/h/150`"
              />
              <img class="radius5" v-else src="@/assets/images/good/good-none.png" />
            </div>
            <div class="flex flex-auto flex-column justify-between addCart_good_main f13">
              <p class="red f15 fb" v-if="detail.sellFactPrice">
                ¥<span class="f26 lin30">{{ detail.sellFactPrice }}</span>
              </p>
              <p class="gray6 f20" v-else><span>暂无价格</span></p>
              <p class="gray9 f13">
                库存<span class="gray3 pad5-l">{{ detail.currQuantity }}件</span>
              </p>
              <p class="f13 flex" v-if="specification.specType === 1">
                <span class="gray9 flex-shrink">已选</span>
                <span class="text-overflow flex-auto">
                  <span
                    class="pad5-l gray3"
                    v-for="(sku, index) in specification.skuSpecsList"
                    :key="index"
                    >{{ sku }}</span
                  >
                </span>
              </p>
            </div>
          </div>
          <!-- 多规格 -->
          <div class="pad5-t flex-auto overflow-auto" v-if="specification.specType === 1">
            <div v-for="(item, index) in specification.specialList" :key="index">
              <p class="gray6 f14_rem addCart_specification_head">{{ item.specType }}</p>
              <ul class="clear">
                <li
                  v-for="(spec, index1) in item.specValList"
                  :key="index1"
                  :class="{
                    addCart_specification_active: spec === specification.skuSpecsList[index]
                  }"
                  @click="skuClick(spec, index)"
                >
                  {{ spec }}
                </li>
              </ul>
            </div>
          </div>
          <div class="pad5-t" v-else>
            <p class="gray6 f14_rem addCart_specification_head">规格</p>
            <ul class="clear">
              <li class="addCart_specification_active">{{ detail.spec }}</li>
            </ul>
          </div>
          <div class="clear mar30_t mar15_b" v-if="detail.sellFactPrice">
            <span class="float-left gray6 f14_rem">购买数量</span>
            <div class="float-right">
              <van-stepper
                v-model="addCartNum"
                input-width="120px"
                button-size="24px"
                :class="{
                  'minus-disabled':
                    detail.minOrderQuantity &&
                    detail.minOrderQuantity > 1 &&
                    addCartNum <= detail.minOrderQuantity,
                  'plus-disabled': detail.currQuantity >= addCartNum
                }"
                :max="detail.currQuantity"
                :decimal-length="detail.goodsDigit"
                @blur="formatNum"
                @change="stepperChange"
              />
              <div
                class="f10 pad5-t text-center"
                v-if="detail.minOrderQuantity && detail.minOrderQuantity > 0"
              >
                {{ detail.minOrderQuantity }}{{ detail.mUnitCn }}起订
              </div>
            </div>
          </div>
          <div class="addCart_pop_btn">
            <p
              v-if="detail.currQuantity"
              class="b_red bor-red white f16 lin40 radius50"
              @click="addCartPram"
            >
              {{
                detail.sUnitCn && detail.unitRatio
                  ? `加入购物车(共${Number(
                      (Number(addCartNum) * Number(detail.unitRatio)).toFixed(6)
                    )}${detail.sUnitCn})`
                  : "加入购物车"
              }}
            </p>
            <p v-else class="bg-c2c2c2 white f16 lin40 radius50">库存不足</p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Toast } from "vant";
import { mapState } from "vuex";
import common from "@/assets/js/common";

export default {
  props: {
    goodsList: Array
  },
  data() {
    return {
      isShow: false,
      video: {
        // 视频播放相关参数
        url: "",
        cover: "",
        muted: false,
        loop: true,
        preload: "auto",
        poster: "",
        volume: 1,
        autoplay: true
      },
      detail: {}, // 加入购物车的详情
      addCartShow: false, // 是否显示加购物车选择规则弹框
      specification: {
        specType: 0,
        specialList: [],
        skuSpecsList: []
      },
      addCartNum: 1 // 加入进货车的数量
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {},
  methods: {
    // 加入购物车
    addCart(goods) {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      console.log("goods", goods);
      // https://sc.t.nxin.com/api/platform/activity/goodsList?floorId=480
      this.detail = goods;
      if (goods.minOrderQuantity && goods.minOrderQuantity > 1) {
        this.addCartNum = goods.minOrderQuantity;
      }
      if (goods.specType === 1) {
        const { specType, specialList, skuSpecsIndex } = this.detail;
        const skuSpecsList = skuSpecsIndex.split(" ");
        this.specification = {
          specType,
          specialList,
          skuSpecsList
        };
        this.addCartShow = true;
        return;
      }
      this.addCartPram();
    },
    // 购物车减号
    stepperChange(value) {
      const { detail } = this;
      if (value && Number(value) < Number(detail.minOrderQuantity)) {
        this.$nextTick(() => {
          this.addCartNum = Number(detail.minOrderQuantity);
        });
      }
    },

    addCartPram() {
      const { detail, addCartNum } = this;
      const params = {
        goodsId: detail.goodsId,
        goodsQuantity: detail.specType === 1 ? addCartNum : 1,
        fromShopId: detail.shopIds
      };
      this.$store.dispatch("goodDetails/goodDetails/addCart", { params }).then(data => {
        this.addCartShow = false;
        if (data.success === true) {
          Toast.success("添加成功");
          this.$emit("getCountCart");
        } else if (data.errorcode === -2) {
          window.location.href = `${
            process.env.VUE_APP_APP
          }mob/goods/isShowDisplayPrice.do?goodsId=${detail.goodsId}&url=/mob/shop/shopDetail/${
            detail.shopIds
          }`;
        } else {
          Toast.fail(data.errormsg);
        }
      });
    },

    // 点击跳转
    routerClick(url) {
      if (!url) {
        return;
      }
      this.$router.push(url);
    },

    // 视频播放
    showVideo(url) {
      this.video.url = url;
      this.isShow = true;
    },
    closeVideo() {
      this.isShow = false;
      $(".video-wrap video")
        .get(0)
        .pause();
    },

    // 多规格值点击
    skuClick(sku, index) {
      const { goodsId } = this.detail;
      this.specification.skuSpecsList[index] = sku;
      const skuSpecsIndex = this.specification.skuSpecsList.join(" ");
      this.$store
        .dispatch("goodDetails/goodDetails/getGoodsSkuId", {
          goodsId,
          skuSpecsIndex
        })
        .then(data => {
          console.info("多规格值点击", data);
          const id = data || goodsId;
          this.getGoodsDetail(id);
        });
    },
    getGoodsDetail(goodsId) {
      this.$store
        .dispatch(
          "goodDetails/goodDetails/detail",
          this.$qs.stringify({
            goodsId
          })
        )
        .then(data => {
          const detail = data.data || {};
          // 商品不存在或已下架
          // if (data.code === "402003" || data.code === "402008") {
          //   const ua = navigator.userAgent.toLowerCase();
          //   if (ua.match(/MicroMessenger/i) == "micromessenger") {//eslint-disable-line
          //     wx.miniProgram.getEnv((res) => {
          //       if (res.miniprogram) {
          //         // 小程序
          //         wx.miniProgram.navigateTo({ url: `${process.env.VUE_APP_APP}mob/goods/toCommodityShelves?goodsId=${this.goodsId}` });
          //       }
          //     });
          //   }
          //   window.location.href = `${process.env.VUE_APP_APP}mob/goods/toCommodityShelves?goodsId=${this.goodsId}`;
          //   return;
          // }
          // 设置多规格
          const { specType, specialList, skuSpecsIndex, imgUrl1, goodsPrice } = detail;
          this.detail = {
            ...detail,
            goodsImg: imgUrl1,
            sellFactPrice: goodsPrice.sellFactPrice || ""
          };
          if (specType === 1) {
            const skuSpecsList = skuSpecsIndex.split(" ");
            this.specification = {
              specType,
              specialList,
              skuSpecsList
            };
          }
        });
    },
    // num 输入的数字 scale精确小数位数 negative true负数
    formatNum(event) {
      let { value } = event.target;
      const scale = this.detail.goodsDigit;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp(`^(-)?(\\d{1,8})\\.(\\d{0,${scale}}).*$`);
      value = value.replace(reg, "$1$2.$3");
      value = parseFloat(value);

      if (value && Number(value) < Number(this.detail.minOrderQuantity)) {
        Toast("不可少于最低起订量，请重新输入");
        this.addCartNum = this.detail.minOrderQuantity;
      } else {
        this.addCartNum = value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
